import { useState, useMemo, useEffect, useRef } from "react";
import "../SendSms.css";
import api from "../api";

/* =========================================================================
   API ENDPOINT
   Parish : GET /GetParish → [{ parish_id, parish }]
   ========================================================================= */

const INITIAL_MEMBERS = [
  { sl: 1,  code: 398,  name: "PALLIKUNNATH MARY SUNNY",     mob: "9820018733", dob: "30 Nov 1950", parish: "AIROLI" },
  { sl: 2,  code: 399,  name: "PALLIKUNNATH DEASSY SUNNY",   mob: "9820018733", dob: "28 Dec 1945", parish: "AIROLI" },
  { sl: 3,  code: 473,  name: "JOSE JOSEPH",                 mob: "9869404158", dob: "01 Dec 1955", parish: "AIROLI" },
  { sl: 4,  code: 648,  name: "THOMAS PAUL MOOLAN",          mob: "",           dob: "10 Mar 1955", parish: "AIROLI" },
  { sl: 5,  code: 879,  name: "MALIEKAL VARGHESE GRACY",     mob: "",           dob: "12 May 1948", parish: "AIROLI" },
  { sl: 6,  code: 880,  name: "M. O. VARGHESE",              mob: "",           dob: "20 Sep 1942", parish: "AIROLI" },
  { sl: 7,  code: 1132, name: "ANNIE JOSEPH",                mob: "",           dob: "23 Sep 1942", parish: "AIROLI" },
  { sl: 8,  code: 1275, name: "AKKARA CHACKU LOUIS",         mob: "",           dob: "16 May 1954", parish: "AIROLI" },
  { sl: 9,  code: 1327, name: "LIJU POLSON",                 mob: "",           dob: "12 Feb 1969", parish: "AIROLI" },
  { sl: 10, code: 1328, name: "E. O. POLSON",                mob: "",           dob: "06 Jul 1960", parish: "AIROLI" },
  { sl: 11, code: 1332, name: "K. P. JOSEPH",               mob: "7670501",    dob: "25 Aug 1954", parish: "AIROLI" },
  { sl: 12, code: 1333, name: "LISSY JOSEPH",               mob: "",           dob: "29 Oct 1964", parish: "AIROLI" },
  { sl: 13, code: 1335, name: "ANTONY CHACKO",              mob: "9869393219", dob: "20 May 1961", parish: "AIROLI" },
  { sl: 14, code: 1791, name: "AKKARA CHACKO RAPHY",        mob: "9821986470", dob: "20 Jul 1961", parish: "AIROLI" },
  { sl: 15, code: 1792, name: "SHEEBA RAPHY",               mob: "9821986470", dob: "02 Aug 1973", parish: "AIROLI" },
  { sl: 16, code: 1801, name: "MARY JOSE",                  mob: "",           dob: "24 Dec 1957", parish: "AIROLI" },
  { sl: 17, code: 1803, name: "THAIKATIL JACOB PETER PAUL", mob: "8108684832", dob: "03 May 1945", parish: "AIROLI" },
  { sl: 18, code: 1804, name: "ELSY PETER",                 mob: "7304199942", dob: "13 May 1955", parish: "AIROLI" },
  { sl: 19, code: 1805, name: "C. A. JOSE",                 mob: "",           dob: "21 May 1944", parish: "AIROLI" },
  { sl: 20, code: 1806, name: "ROSY JOSE",                  mob: "7694153",    dob: "01 Oct 1951", parish: "AIROLI" },
  { sl: 21, code: 1807, name: "SUSAMMA CHACKO",             mob: "",           dob: "01 Jan 1957", parish: "AIROLI" },
  { sl: 22, code: 1808, name: "M. C. CHACKO",              mob: "",           dob: "10 Oct 1952", parish: "AIROLI" },
  { sl: 23, code: 1890, name: "Roseline Nazreth Pereira",   mob: "9167212966", dob: "01 Jan 1978", parish: "AIROLI" },
  { sl: 24, code: 2041, name: "MARY FRANCIS",              mob: "",           dob: "05 Nov 1951", parish: "AIROLI" },
  { sl: 25, code: 2143, name: "P. D. STEPHEN",             mob: "9594055545", dob: "12 Jun 1970", parish: "AIROLI" },
];

const validMob = (m) => /^[6-9]\d{9}$/.test((m || "").trim());
const mobState = (m) => (!(m || "").trim() ? "missing" : validMob(m) ? "ok" : "bad");

/* ══════════════════════════════════════════════════
   AUTOCOMPLETE COMPONENT
   Same pattern as ConsignmentBooking AutoComplete —
   uses cb-ac / cb-ac-box / cb-ac-drop / cb-ac-opt CSS classes
   options: [{ value, label }]
══════════════════════════════════════════════════ */
function AutoComplete({ options, value, onChange, placeholder = "Search…", loading = false }) {
  const [query, setQuery]           = useState("");
  const [isOpen, setIsOpen]         = useState(false);
  const [focused, setFocused]       = useState(-1);
  const [cursorMoved, setCursorMoved] = useState(false);
  const wrapRef  = useRef(null);
  const inputRef = useRef(null);

  // Sync display text when value changes externally
  const selected = options.find((o) => o.value === value);
  useEffect(() => {
    if (selected) setQuery(selected.label);
    else setQuery("");
  }, [value, selected]);

  // Filter options by typed query
  const filtered = options.filter(
    (o) => o.value !== undefined &&
      o.label.toLowerCase().includes((query || "").toLowerCase())
  );

  // Highlight matched text — same as ConsignmentBooking hl()
  function hl(text, q) {
    if (!q) return text;
    const i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return text;
    return (
      <>
        {text.slice(0, i)}
        <mark>{text.slice(i, i + q.length)}</mark>
        {text.slice(i + q.length)}
      </>
    );
  }

  function choose(opt) {
    onChange(opt.value);
    setQuery(opt.label);
    setIsOpen(false);
    setFocused(-1);
    setCursorMoved(false);
  }

  function clear() {
    onChange("");
    setQuery("");
    setIsOpen(true);
    setFocused(-1);
  }

  // Close on outside click
  useEffect(() => {
    function handle(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setIsOpen(false);
    }
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  function handleKeyDown(e) {
    if (!isOpen) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        setIsOpen(true);
        setCursorMoved(true);
      }
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setCursorMoved(true);
      setFocused((f) => Math.min(f + 1, filtered.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setCursorMoved(true);
      setFocused((f) => Math.max(f - 1, 0));
    } else if (e.key === "Escape") {
      setIsOpen(false);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (cursorMoved && filtered.length > 0) {
        const target = filtered[focused] || filtered[0];
        if (target) choose(target);
      } else if (filtered.length === 1) {
        choose(filtered[0]);
      } else {
        setIsOpen(false);
      }
    }
  }

  return (
    <div className="cb-ac" ref={wrapRef}>
      <div className={`cb-ac-box${isOpen ? " open" : ""}`}>
        <input
          ref={inputRef}
          className="cb-ac-in"
          type="text"
          autoComplete="off"
          placeholder={loading ? "Loading…" : placeholder}
          disabled={loading}
          value={query}
          onFocus={() => { setIsOpen(true); setCursorMoved(false); }}
          onClick={() => { if (!isOpen) setIsOpen(true); }}
          onChange={(e) => { setQuery(e.target.value); setIsOpen(true); setFocused(-1); }}
          onKeyDown={handleKeyDown}
        />
        {value && (
          <span className="cb-ac-x on" onMouseDown={(e) => { e.preventDefault(); clear(); }}>×</span>
        )}
        <span className="cb-ac-chev" onMouseDown={(e) => { e.preventDefault(); setIsOpen((o) => !o); }}>▾</span>
      </div>

      {isOpen && !loading && (
        <div className="cb-ac-drop open">
          {filtered.length === 0 ? (
            <div className="cb-ac-empty">No matches found</div>
          ) : (
            filtered.map((opt, i) => (
              <div
                key={opt.value}
                className={`cb-ac-opt${opt.value === value ? " sel" : ""}${i === focused ? " foc" : ""}`}
                onMouseDown={(e) => { e.preventDefault(); choose(opt); }}
                onMouseEnter={() => setFocused(i)}
              >
                {hl(opt.label, query)}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════ */
export default function SendSms() {
  const [members, setMembers] = useState([]);

  // ── Parish ────────────────────────────────────────
  const [parishOpts, setParishOpts]   = useState([]);   // [{ value: parish_id, label: parish }]
  const [parishLoading, setParishLoading] = useState(true);
  const [parish, setParish]           = useState("");   // selected parish name

  const [parishId, setParishId]         = useState(null);  // numeric id of selected parish
  const [memberOpts, setMemberOpts]     = useState([]);     // [{ value: Member_Code, label: Member_Name }]
  const [membersLoading, setMembersLoading] = useState(false);

  // ── Financial Year ─────────────────────────────────
  const [finYearOpts, setFinYearOpts]   = useState([]);   // [{ finyear, finyear_code }]
  const [finYearLoading, setFinYearLoading] = useState(true);
  const [finYearCode, setFinYearCode]   = useState(null); // selected finyear_code

  // ── Other filters ─────────────────────────────────
  const [memberFilter, setMemberFilter] = useState("");

  const [search, setSearch]             = useState("");

  // ── Selection + message ───────────────────────────
  const [selected, setSelected] = useState(new Set());
  const [sending, setSending]   = useState(false);
  const [msg, setMsg]           = useState("");

  // ── SMS Template ──────────────────────────────────
  const [templateLoading, setTemplateLoading] = useState(true);

  // ── Toast ─────────────────────────────────────────
  const [toastMsg, setToastMsg]   = useState("");
  const [toastShow, setToastShow] = useState(false);
  const toastTimer = useRef(null);

  // ── Confirm dialog ────────────────────────────────
  const [dialogOpen, setDialogOpen] = useState(false);

  const selAllRef = useRef(null);

  /* ══════════════════════════════════════════════════
     FETCH PARISHES — GET /GetParish
     Returns: [{ parish_id, parish }]
     Mapped to AutoComplete format: [{ value: parish_id, label: parish }]
  ══════════════════════════════════════════════════ */
  useEffect(() => {
    const loadParishes = async () => {
      setParishLoading(true);
      try {
        const res = await api.get('/SMSSend/GetParish');
        const opts = res.data.map((p) => ({
          value: p.parish_id,    // numeric id
          label: p.parish,       // display name e.g. "AIROLI"
        }));
        setParishOpts(opts);
        // Auto-select first parish and trigger member load
        if (opts.length > 0) {
          setParish(opts[0].label);
          setParishId(opts[0].value);
        }
      } catch (err) {
        console.error('Failed to load parishes:', err);
      } finally {
        setParishLoading(false);
      }
    };
    loadParishes();
  }, []);

  /* ══════════════════════════════════════════════════
     FETCH FINANCIAL YEARS — GET /GetFinYears?companyCode=1
     Returns: [{ finyear, finyear_code }] ordered finyear_code DESC
  ══════════════════════════════════════════════════ */
  useEffect(() => {
    const loadFinYears = async () => {
      setFinYearLoading(true);
      try {
        const res = await api.get('/SMSSend/GetFinYears', { params: { companyCode: 1 } });
        setFinYearOpts(res.data);
        // Auto-select the latest finyear (first row, query is ORDER BY finyear_code DESC)
        if (res.data.length > 0) setFinYearCode(res.data[0].finyear_code);
      } catch (err) {
        console.error('Failed to load financial years:', err);
      } finally {
        setFinYearLoading(false);
      }
    };
    loadFinYears();
  }, []);

  /* ══════════════════════════════════════════════════
     FETCH SMS TEMPLATE — GET /GetSMSContent
     Returns: plain string (the Sms_message from Sms_Configuration)
  ══════════════════════════════════════════════════ */
  useEffect(() => {
    const loadSmsTemplate = async () => {
      setTemplateLoading(true);
      try {
        const res = await api.get('/SMSSend/GetSMSContent');
        if (res.data) setMsg(res.data);
      } catch (err) {
        console.error('Failed to load SMS template:', err);
      } finally {
        setTemplateLoading(false);
      }
    };
    loadSmsTemplate();
  }, []);

  // When AutoComplete fires onChange it gives us parish_id (numeric value).
  // Store both the id (for API call) and the label (for table filtering).
  const handleParishChange = (id) => {
    const opt = parishOpts.find((o) => o.value === id);
    setParish(opt ? opt.label : "");
    setParishId(id || null);
    setMemberFilter("");   // reset member selection on parish change
  };

  /* ══════════════════════════════════════════════════
     FETCH MEMBERS — GET /GetMemberDateList?parishId=5&companyCode=1
     Calls Memberselect stored proc via the API.
     Returns: [{ MemberId, Member_Name, MemberCodeName, member_code,
                  parish, parish_code, Location, NewMobNo,
                  DateOfBirth, DateOfJoin, DOD }]
  ══════════════════════════════════════════════════ */
  const formatDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return "";
    return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  const loadMembers = async (pId) => {
    if (!pId) return;
    setMembersLoading(true);
    try {
      const res = await api.get('/SMSSend/GetMemberDateList', { params: { parishId: pId, companyCode: 1 } });
      setMemberOpts(
        res.data.map((m) => ({
          value: m.member_code,
          label: m.member_Name,
        }))
      );
      setMembers(res.data.map((m, i) => ({
        sl:     i + 1,
        code:   m.member_code,
        name:   m.member_Name,
        mob:    m.newMobNo      || "",
        dob:    formatDate(m.dateOfBirth),
        parish: m.parish || parish,
      })));
    } catch (err) {
      console.error('Failed to load members:', err);
    } finally {
      setMembersLoading(false);
    }
  };

  // Auto-load members whenever the selected parish changes (including the initial auto-selected parish on first load).
  useEffect(() => {
    loadMembers(parishId);
  }, [parishId]); // eslint-disable-line

  // Current value for AutoComplete = the parish_id of the selected parish
  const parishValue = parishOpts.find((o) => o.label === parish)?.value ?? "";

  // Member AutoComplete options: "ALL" pinned first, then "code — name" for each member
  const memberAcOpts = useMemo(() => [
    ...memberOpts.map((m) => ({ value: String(m.value), label: `${m.value} — ${m.label}` })),
  ], [memberOpts]);

  /* ══════════════════════════════════════════════════
     DERIVED DATA
  ══════════════════════════════════════════════════ */
  const view = useMemo(() => {
    const q = search.trim().toLowerCase();
    return members.filter((m) => {
      if (parish && parish !== "ALL" && m.parish !== parish) return false;
      if (memberFilter && String(m.code) !== memberFilter) return false;
      if (q && !(m.name.toLowerCase().includes(q) || String(m.code).includes(q))) return false;
      return true;
    });
  }, [members, parish, memberFilter, search]);

  const sendableInView = useMemo(() => view.filter((m) => mobState(m.mob) === "ok"), [view]);
  const selectedAll    = useMemo(() => members.filter((m) => selected.has(m.code)), [members, selected]);
  const recipients     = useMemo(
    () => members.filter((m) => selected.has(m.code) && mobState(m.mob) === "ok"),
    [members, selected]
  );

  const charCount = msg.length;
  const segCount  = msg.length === 0 ? 0 : msg.length <= 160 ? 1 : Math.ceil(msg.length / 153);
  const skipCount = selectedAll.length - recipients.length;
  // Backend reads SMS content from Sms_Configuration table,
  // so the frontend message is only a preview — not required for sending.
  const sendReady = recipients.length > 0;

  const personalize = (text, name) =>
    text.replace(/\{name\}/g, name.split(" ").slice(0, 2).join(" "));

  let prevTo = "No recipient selected";
  if (recipients.length === 1) prevTo = `To ${recipients[0].name} · ${recipients[0].mob}`;
  else if (recipients.length > 1) prevTo = `To ${recipients[0].name} +${recipients.length - 1} more`;

  const previewWho      = recipients[0] || selectedAll[0];
  const showPlaceholder = !msg.trim();
  const previewText     = showPlaceholder
    ? "Your message preview will appear here."
    : personalize(msg, previewWho ? previewWho.name : "Member");

  // Select-all checkbox indeterminate sync
  useEffect(() => {
    if (!selAllRef.current) return;
    const pool   = sendableInView;
    const chosen = pool.filter((m) => selected.has(m.code)).length;
    selAllRef.current.disabled      = pool.length === 0;
    selAllRef.current.checked       = pool.length > 0 && chosen === pool.length;
    selAllRef.current.indeterminate = chosen > 0 && chosen < pool.length;
  }, [sendableInView, selected]);

  /* ══════════════════════════════════════════════════
     HANDLERS
  ══════════════════════════════════════════════════ */
  const toast = (text) => {
    setToastMsg(text); setToastShow(true);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToastShow(false), 2600);
  };
  useEffect(() => () => clearTimeout(toastTimer.current), []);

  const toggleRow = (code, checked) =>
    setSelected((prev) => { const n = new Set(prev); checked ? n.add(code) : n.delete(code); return n; });

  const toggleSelAll = (checked) =>
    setSelected((prev) => {
      const n = new Set(prev);
      sendableInView.forEach((m) => (checked ? n.add(m.code) : n.delete(m.code)));
      return n;
    });



  const handleRefresh = async () => {
    await loadMembers(parishId);
    toast("Member list refreshed");
  };

  const handleCancel = () => { setSelected(new Set()); setMsg(""); toast("Selection and message cleared"); };
  const handleExit   = () => toast("Closing Send SMS…");
  const handleSendClick     = () => { if (sendReady) setDialogOpen(true); };
  /* ══════════════════════════════════════════════════
     SEND SMS — POST /SendSMS?memberCode=..&mobileNo=..
     Called once per checked recipient (member-wise),
     since the backend sends one SMS per call.
  ══════════════════════════════════════════════════ */
  const handleDialogConfirm = async () => {
    const toSend = recipients; // checked rows with a valid mobile number
    setDialogOpen(false);
    setSending(true);

    let okCount = 0;
    let failCount = 0;

    for (const m of toSend) {
      try {
        const res = await api.post('/SMSSend/SendSMS', null, {
          params: { memberCode: m.code, mobileNo: (m.mob || "").trim() },
        });
        if (res.status >= 200 && res.status < 300) okCount++;
        else failCount++;
      } catch (err) {
        console.error(`SendSMS failed for member ${m.code}:`, err);
        failCount++;
      }
    }

    setSending(false);
    if (failCount === 0) {
      toast(`✓ SMS sent successfully to ${okCount} member${okCount === 1 ? "" : "s"}`);
    } else {
      toast(`Sent to ${okCount} · Failed for ${failCount} member${failCount === 1 ? "" : "s"}`);
    }
  };

  /* ══════════════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════════════ */
  return (
    <div className="sms-app">
      <div className="app">

        {/* Title bar */}
        <div className="titlebar">
          <div className="mark">SSS</div>
          <div>
            <h1>Send SMS</h1>
            <div className="sub">Social Security Scheme · Kalyan Diocese</div>
          </div>
          <div className="right">Financial Year<br /><b>{finYearOpts.find((f) => f.finyear_code === finYearCode)?.finyear || "—"}</b></div>
        </div>

        {/* Filters */}
        <div className="filters">

          {/* ── Parish — AutoComplete fetched from /GetParish ── */}
          <div className="field">
            <label>Parish</label>
            <AutoComplete
              options={parishOpts}
              value={parishValue}
              onChange={handleParishChange}
              placeholder="Search parish…"
              loading={parishLoading}
            />
          </div>

          {/* Year — loaded from /GetFinYears?companyCode=1 */}
          <div className="field">
            <label htmlFor="fYear">Year</label>
            <select
              id="fYear"
              value={finYearCode ?? ""}
              onChange={(e) => setFinYearCode(Number(e.target.value))}
              disabled={finYearLoading}
            >
              {finYearLoading && <option value="">Loading…</option>}
              {!finYearLoading && finYearOpts.length === 0 && <option value="">No financial years found</option>}
              {finYearOpts.map((fy) => (
                <option key={fy.finyear_code} value={fy.finyear_code}>
                  {fy.finyear}
                </option>
              ))}
            </select>
          </div>

          {/* Member — loaded from /GetMembers?parishId={parishId} */}
          <div className="field">
            <label htmlFor="fMember">Member</label>
            <AutoComplete
              options={memberAcOpts}
              value={memberFilter}
              onChange={(val) => setMemberFilter(val || "")}
              placeholder="Search member code or name…"
              loading={membersLoading}
            />
          </div>



          {/* Refresh — quick access next to SMS Type */}
          <div className="field">
            <label>&nbsp;</label>
            <button className="ghost filter-refresh" onClick={handleRefresh}>
              <span className="ico">⟳</span>Refresh
            </button>
          </div>
        </div>

        <div className="body">
          {/* Members grid */}
          <div className="grid-wrap">
            <div className="grid-head">
              <span className="lbl">Members</span>
              <div className="search">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" />
                </svg>
                <input
                  id="search" type="text" placeholder="Search name or code"
                  value={search} onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th className="c-sel">
                      <input ref={selAllRef} type="checkbox" className="cb"
                        title="Select all with a valid number"
                        onChange={(e) => toggleSelAll(e.target.checked)} />
                    </th>
                    <th className="c-sl">Sl</th>
                    <th>Code</th>
                    <th>Member Name</th>
                    <th>Mobile No</th>
                    <th>DOB</th>
                  </tr>
                </thead>
                <tbody>
                  {view.map((m) => {
                    const st    = mobState(m.mob);
                    const isSel = selected.has(m.code);
                    let mobCell;
                    if (st === "ok")       mobCell = <span className="num">{m.mob}</span>;
                    else if (st === "bad") mobCell = <span className="pill bad">⚠ Invalid no.</span>;
                    else                   mobCell = <span className="pill miss">No number</span>;
                    return (
                      <tr key={m.code} className={`${isSel ? "sel " : ""}${st !== "ok" ? "unsendable" : ""}`}>
                        <td className="c-sel">
                          <input type="checkbox" className="cb rowcb" checked={isSel} disabled={st !== "ok"}
                            onChange={(e) => toggleRow(m.code, e.target.checked)} />
                        </td>
                        <td className="c-sl">{m.sl}</td>
                        <td className="code">{m.code}</td>
                        <td className="name">{m.name}</td>
                        <td className="mob">{mobCell}</td>
                        <td className="num">{m.dob}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {view.length === 0 && <div className="empty">No members match the current filters.</div>}
            </div>
          </div>

          {/* Composer */}
          <div className="composer">
            <h2>Message</h2>
            <textarea id="msg"
              placeholder={templateLoading ? "Loading template…" : "Pick an SMS type above to load a template, or type your own message…"}
              disabled={templateLoading}
              value={msg} onChange={(e) => setMsg(e.target.value)} />
            <div className="meter">
              <span><b>{charCount}</b> / 160 chars</span>
              <span className="seg"><b>{segCount}</b> SMS</span>
            </div>
            <div className="hint">Use <code>{"{name}"}</code> to insert each member's name automatically.</div>

            <div>
              <div className="preview-label">Preview</div>
              <div className="phone">
                <div className="to">{prevTo}</div>
                <div className={`bubble ${showPlaceholder ? "placeholder" : ""}`}>{previewText}</div>
                <div className="stamp">delivered · just now</div>
              </div>
            </div>

            <div className="summary">
              <div className="cell"><div className="n ok">{recipients.length}</div><div className="k">Will receive</div></div>
              <div className="cell"><div className="n skip">{skipCount}</div><div className="k">No valid no.</div></div>
              <div className="cell"><div className="n">{selectedAll.length}</div><div className="k">Selected</div></div>
            </div>
          </div>
        </div>

        {/* Action bar */}
        <div className="actions">
          <button className="ghost" onClick={handleCancel}>Cancel</button>
          <button className="ghost" onClick={handleExit}>Exit</button>
          <button className="btn-send" disabled={!sendReady || sending} onClick={handleSendClick}>
            {sending ? "Sending…" : recipients.length > 0 ? `Send SMS to ${recipients.length}` : "Send SMS"}
          </button>
        </div>
      </div>

      {/* Toast */}
      <div className={`toast ${toastShow ? "show" : ""}`}>
        <span className="dot"></span><span>{toastMsg}</span>
      </div>

      {/* Confirm dialog */}
      <div className={`overlay ${dialogOpen ? "show" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setDialogOpen(false)}>
        <div className="dialog">
          <h3>Send SMS to {recipients.length} member{recipients.length === 1 ? "" : "s"}?</h3>
          <p>
            This message will be delivered to <b>{recipients.length}</b> member{recipients.length === 1 ? "" : "s"} with a valid mobile number
            {skipCount > 0
              ? (<>. <b>{skipCount}</b> selected member{skipCount === 1 ? "" : "s"} will be skipped (no valid number on file).</>)
              : (".")}
          </p>
          <div className="row">
            <button className="ghost" onClick={() => setDialogOpen(false)}>Cancel</button>
            <button className="confirm" onClick={handleDialogConfirm}>Send now</button>
          </div>
        </div>
      </div>
    </div>
  );
}
